<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body form-wrapper quote-form-wrapper left">
      <div class="block">
        <ProductForm :product="product" @save-product="handleSaveProduct"></ProductForm>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ProductForm from './forms/product-form'
export default {
  name: 'NewProduct',
  components: {
    ProductForm
  },
  data () {
    return {
      product: {
        product_name: '',
        erp_id: '',
        model: '',
        customer_id: '',
        customer: {},
        product_type: '',
        product_alias: ''
      }
    }
  },
  computed: {
    pageTitle: function () {
      document.title = this.$t('menu.product.new_product')
      return document.title
    }
  },
  methods: {
    ...mapActions(['createProduct']),
    handleSaveProduct (data) {
      this.createProduct(data).then(res => {
        let productId = res.data.id
        this.$Message.success('Product has been successfully created!')
        this.$router.push({
          name: 'menu.product.edit',
          params: {
            productId: productId
          }
        })
      })
    }
  }
}
</script>
